import React from 'react';
import RenderScreeningData from './RenderScreeningData';

function Screening() {
  return (
    <div id="pat-appt-main-scrn" className="preauth-Maingrid-Pat">
      <div className="c-mid-bdy-hdr clear-top10">
        <span className="widget-hdr-title bold clear-top">Screening:</span>
        {/* <span className="actn-yes" style={{ width: 'unset' }}>
          Add New
        </span> */}
      </div>
      <div className="preauth-Maingrid-Patbdy grid-sec clear-top10">
        <RenderScreeningData />
      </div>
    </div>
  );
}

export default Screening;
